import moment from "moment";
import React, { useEffect, useState } from "react";
import { BackButton, TableData } from "../../components";
import { errorAlert } from "../../helpers/alerts";
import { getBinnacleService } from "../../services/panelService";
import { useNavigate } from "react-router-dom";
import { maxWidth } from "@mui/system";

const PanelBinnacleScreen = ({ slim }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const shortList = new Array(15).fill({});

  useEffect(() => {
    setLoading(true)
    getBinnacleService({ page: 0, limit: 300 })
      .then((response) => setList(response))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {!slim && <BackButton name={'Regresar'} click={() => navigate(-1)} />}
      <TableData
        title={"Bitácora"}
        onTitleClick={() => slim && navigate('../bitacora')}
        rowsPerPageOpt={50}
        autonumber={false}
        pagination={false}
        loading={loading}
        headerStyle={slim && {
          fontSize: slim ? 11 : 16,
        }}
        dataRows={(slim ? shortList.map((item, i) => list[i] || {}) : list).map((item) => ({
          ...item,
          style: {
            fontSize: slim ? 11 : 14,
          }
        }))}
        dataTitle={[
          "Hora",
          "Tipo",
          "Concepto",
          "Usuario",
        ]}
        formatter={({
          createdAt,
          event,
          description,
          userName
        }) => ([
          createdAt ? moment(createdAt).format(slim ? 'HH:mm:ss' : 'DD/MM/YY HH:mm:ss') : '-',
          event || '-',
          description ? { type: 'text', value: description, maxWidth: 80 } : '-',
          userName ? { type: 'text', value: userName, maxWidth: 80 } : '-',
        ])}
      />
    </>
  );
};

export default PanelBinnacleScreen;
